import fetchCustom from '../../wp_helpers/fetchCustom';
import getResponseJson from '../../wp_helpers/getResponseJson';
import { appendQueryParams, slugify } from '../../wp_helpers/helpers';

export const saveAttribute = async (saveUrl, payload, locale) => {
    if (!saveUrl || !payload) return false;
    const url = appendQueryParams(saveUrl, { lang: locale });
    const response = await fetchCustom(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
        body: JSON.stringify(payload),
    });
    if (response.ok) {
        const { result } = await getResponseJson(response);
        const { id_, default: defaultValue } = result[0];
        return { id: id_, text: defaultValue };
    }
    return null;
};

export const getESCODataByID = async (id) => {
    const response = await fetchCustom(appendQueryParams('/esco/search', { value: id }));
    if (response.ok) {
        return await getResponseJson(response);
    }
    return null;
}

export const getESCOData = async (uri, text, locale, rest = {}) => {
    if (!uri) return;

    const esco = await getESCODataByID(uri);
    if (!esco?.items?.length) return;

    const slug = slugify(uri);
    if (!slug) {
        return false;
    }
    const translatedTexts = esco.items.reduce((acc, item) => {
        acc[item.lang] = item.label;
        return acc;
    }, {});

    return {
        default: text,
        uri: uri,
        id_: slug,
        [locale]: text,
        ...translatedTexts,
        ...rest
    };
};